var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7zm5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM3 16a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a1 1 0 1 1-2 0v-4H5v4a1 1 0 1 1-2 0z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }